import React, {FC, useEffect, useRef, useState} from "react";
import Tag from "components/Tag/Tag";
import { SinglePageType } from "./PageSingle";
import SingleAuthor from "./SingleAuthor";
import SingleCommentForm from "./SingleCommentForm";
import SingleCommentLists from "./SingleCommentLists";
import SingleContentDemo from "./SingleContentDemo";
import {useLocation} from "react-router";
import {addDoc, collection, doc, getDoc, increment, serverTimestamp, setDoc, updateDoc} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import NcLink from "../../components/NcLink/NcLink";
import {displayToast, toastType} from "../../global/Functions";

export interface SingleContentProps {
  data: any;
}

const SingleContent: FC<SingleContentProps> = ({data}) => {
  const {tags, author, commentCount, comments} = data;
  const commentRef = useRef<HTMLDivElement>(null);
  const [comment, setComment] = useState("");
  const location = useLocation();

  useEffect(() => {
    //  SCROLL TO COMMENT AREA
    if (location.hash !== "#comment") {
      return;
    }
    //
    if (location.hash === "#comment") {
      setTimeout(() => {
        if (commentRef.current) {
          commentRef.current.scrollIntoView();
        }
      }, 500);
    }
  }, [location]);


  const submitComment = async (e: any) => {
    e.preventDefault();

    if (!auth.currentUser?.uid){
      displayToast("Log In to leave a comment", toastType.warn);
      return;
    }

    const postDocRef = doc(db, "posts", `${data.userId}/posts/${data.id}`);
    const commentCollectionRef = collection(postDocRef, "comments");
    const userData = await getDoc(doc(db, "users", `${auth.currentUser?.uid}`))

    try{
      await setDoc(doc(commentCollectionRef, `${data.commentCount + 1}_${Date.now()}`), {
        id: `${data.commentCount + 1}_${Date.now()}`,
        author: {
          id: auth.currentUser?.uid,
          href: `/author/the-demo-author-slug/${auth.currentUser?.uid}`,
          count: 0,
          desc: "Web 3 enthusiast",
          jobName: "Author Job",
          avatar: auth.currentUser?.photoURL,
          ...userData.data()
        },
        createdAt: serverTimestamp(),
        content: comment,
        parentId: null,
        heartCount: 0,
        childrens: null,
        postId: data.id
      })
      await updateDoc(postDocRef, {commentCount: increment(1), priority: increment(10)})
      displayToast("Comment Submitted", toastType.success);
    } catch (error) {
      displayToast("Something went wrong!", toastType.error)
    }
    e.target.reset();
  }
  return (
    <div className="nc-SingleContent space-y-10">
      {/* ENTRY CONTENT */}
      <div
        id="single-entry-content"
        className="prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
      >
        {/* THIS IS THE DEMP CONTENT */}
        {/* IF YOUR DATA IS JSON, YOU CAN USE render with html-react-parser (https://www.npmjs.com/package/html-react-parser) */}
        <SingleContentDemo content={data.content}/>
      </div>

      {/* TAGS */}
      <div className="max-w-screen-md mx-auto flex flex-wrap">
        {tags.map((item: any) => (
          <Tag hideCount key={item.id} tag={item} className="mr-2 mb-2"/>
        ))}
      </div>

      {/* AUTHOR */}
      <div className="max-w-screen-md mx-auto border-b border-t border-neutral-100 dark:border-neutral-700"></div>
      <div className="max-w-screen-md mx-auto ">
        <SingleAuthor author={author}/>
      </div>
      {/* COMMENT FORM */}
      <div
        id="comment"
        ref={commentRef}
        className="max-w-screen-md mx-auto pt-5"
      >
        <h3 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
            Comments ({commentCount})
        </h3>
        {
          auth.currentUser?.uid ?
            <SingleCommentForm
              // onClickSubmit={(id) => console.log(id)}
              onChange={(e) => setComment(e.target.value)}
              onClickSubmit={(e) => submitComment(e)}
              onClickCancel={() => {setComment("")}}
            /> :
            <NcLink to="/login">
              Log in to comment
            </NcLink>
        }
      </div>

      {/* COMMENTS LIST */}
      <div className="max-w-screen-md mx-auto">
        <SingleCommentLists comments={comments} data={data}/>
      </div>
    </div>
  );
};

export default SingleContent;
